'use strict';

function CnInviteImportInstructionsController() {
  var vm = this;

  vm.$onInit = $onInit;
  vm.toggleInstruction = toggleInstruction;

  function $onInit() {
    vm.toggle = vm.toggle === true || false;
  }

  function toggleInstruction() {
    vm.toggle = !vm.toggle;
  }
}

module.exports = CnInviteImportInstructionsController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-invite-import-instructions/cn-invite-import-instructions.controller.js
 ** module id = 82
 ** module chunks = 0
 **/